import { createContext } from "react";

/**
 * The body context value.
 */
export interface BodyContextValue {
  /**
   * The body size.
   */
  readonly size: "medium" | "small" | "mini";
}

/**
 * The body context.
 */
export const BodyContext = createContext<BodyContextValue>({
  size: "small",
});
